<template>
    <pm-app-component hide-sidebar barColor="#8dc243" :backBtnCb="backBtnCb">
        <template>
            <template slot="mobile-toolbar">
                <pm-application-bar>
                    {{ $t('photos.title') }}
                </pm-application-bar>
                <!--mdi class="white--text" @click="toggleGrid" :key="grid">
                    <template v-if="grid===4">checkerboard</template>
                    <template v-else-if="grid===3">grid</template>
                    <template v-else-if="grid===2">grid-large</template>
                    <template v-else>view-agenda-outline</template>
                </mdi-->
            </template>

            <div id="main-container" class="app-content-container" style="background: #fff; padding: 0!important; box-shadow: inset 0 8px 15px rgba(0,0,0,.03);">

                <div style="background: none!important; position: absolute; top: 0px; bottom: 0px; left: 0; right: 0; padding: 0; x-box-shadow: 0 -8px 15px rgba(0,0,0,.03), 0 8px 15px rgba(0,0,0,.03);
                display: flex; flex-direction: column;">
                    <div style="border-bottom: 1px solid #f6f6f6; text-align: center; padding:10px 15px; box-shadow: 0 0 10px rgba(0,0,0,.08); background: rgba(0,0,0,.05); color: #000;">
                        <span style="font-weight: 600">{{ title }}</span>
                    </div>

                    <div :class="['pm-gallery-grid-'+8]" style="flex-grow: 1; flex-shrink: 1; overflow-y: auto; -webkit-overflow-scrolling: touch; scroll-behavior: smooth;">
                        <pm-gallery-media-list ref="mediaList" @open="openViewer" :id="id" />
                    </div>
                </div>
            </div>
        </template>
        <pm-photo-swipe ref="photoSwipe" @toggleFavved="reload" />
    </pm-app-component>
</template>


<script>
import PmPhotoSwipe from "./photoswipe";
import toolbarMixin from "../../extensions/mixins/mixin-toolbar";
import ErrorBoundary from "@/components/core/error-boundary";
import galleryCategories from "../../configs/gallery/categories.json";
import childCategories from "../../configs/gallery/child-categories.json";
import mixinComputedTitle from "./mixin-computed-title";
import PmGalleryMediaList from "./media-list";

const defaultGrid = 2;

export default {
    name: "PmModGallery",
    mixins: [
        toolbarMixin,
        mixinComputedTitle
    ],
    components: {
        ErrorBoundary,
        PmGalleryMediaList,
        PmPhotoSwipe
    },
    data: () => ({
        grid: defaultGrid,
    }),

    computed: {
        id() {
            return parseInt(this.$route.params.id);
        },
        settings() {
            return childCategories.filter(i => i.id === this.id)[0];
        },
        categoryTitle() {
            try {
                const parent = galleryCategories.filter((p) => {
                    return(p.id === this.settings.parent[0])
                })[0];
                return parent.title[this.$store.state.language] || parent.title.en;
            } catch(error) {
                captureException(error);
                console.error("Error getting title", error.message);
                return "Untitled";
            }
        },
    },
    created() {
        this.t0 = performance.now()
        // if (localStorage.getItem('galleryGrid')) this.grid = parseInt(localStorage.getItem('galleryGrid'));
        window.prevGalleryId = this.id;
    },
    mounted() {
        var t1 = performance.now()
        // alert("Call to doSomething took " + (t1 - this.t0) + " milliseconds.")
    },
    activated() {
        window.prevGalleryId = this.id;
    },
    methods: {
        backBtnCb() {
            this.$router.push('/gallery')
        },
        reload() {
            this.$refs['mediaList'].reload();
        },
        openViewer(params) {
            const [idx, tag, items] = params;
            let flatItems = [];
            let listIdx = -1;
            let i = 0;
            const favourites = items['favourites'] ? items['favourites'].length : 0;
            Object.keys(items).forEach((key) => {
                if (listIdx < 0) {
                    if (tag !== key) i += items[key].length;
                    else listIdx = i + idx;
                }
                flatItems.push(...items[key]);
            });
            this.$refs['photoSwipe'].init({
                start: listIdx,
                items: flatItems,
                galleryId: this.id,
                galleryTitle: this.title,
                categoryTitle: this.categoryTitle,
                favourites: favourites,
            });
        },
        toggleGrid() {
            this.grid--;
            if (this.grid === 0) this.grid = 4;
            localStorage.setItem('galleryGrid', this.grid);
        },
    },
    toolbar() {
        const items = [];

        items.push({
            mdi: "image-outline",
            text: "Photos",
            active: true,
            callback: () => {
                this.$router.push("/gallery");
            },
        });

        items.push({
            mdi: "emoticon-happy-outline",
            text: "Before-after",
            callback: () => {
                this.$router.push('/gallery-before-after').catch(_ => {});
            },
        });

        items.push({
            mdi: "heart-outline",
            text: "Favourites",
            callback: () => {
                this.$router.push('/gallery-favourites');
            },
        });

        items.push({
            back: true,
            callback: () => {
                this.$router.push("/gallery");
            },
        });

        return ([items]);
    },
};

</script>
